import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  fetchTargetMappingSchemas,
  fetchInvoiceTargetMappingInformationById
} from 'redux/targetFields/TargetFieldsActions';
import ImportDescriptionPanel from './ImportDescriptionPanel';

const mapStateToProps = ({ targetFields, profiles }) => ({
  targetSchemas: targetFields.schemas,
  profileTargetId: profiles.profile.targetId
});

const mapDispatchToProps = dispatch => ({
  targetFieldsActions: bindActionCreators({
    fetchTargetMappingSchemas,
    fetchInvoiceTargetMappingInformationById
  }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ImportDescriptionPanel);



// WEBPACK FOOTER //
// ./src/components/importProfile/comp/importDescriptionPanel/ImportDescriptionPanelConnector.js